import cn from "classnames"
import ReactMarkdown from "react-markdown"

import { Flex, Skeleton, Spin, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { LoadingOutlined } from "@/icons"
import { StatusKai } from "@/molecules/StatusKai"

import styles from "./DescriptionAlert.module.scss"

import type { DescriptionAlertProps } from "."

export const DescriptionAlert = (props: DescriptionAlertProps) => {
  const { description, isFalsePositive = null, isLoading } = props
  const { t } = useTranslation()
  const skeletonArray = Array.from({ length: 5 })

  return (
    <Flex vertical gap={32}>
      <Flex vertical gap={10} className={styles.container}>
        {isLoading && (
          <Flex gap={10} align="center">
            <Spin
              indicator={<LoadingOutlined spin className={styles.spin} />}
            />
            <Text className={styles.textColor}>
              {t("triage.drawer.dataFlow.loading")}
            </Text>
          </Flex>
        )}
        {!isLoading && (
          <>
            <StatusKai isFalsePositive={isFalsePositive} t={t} />
            <div className={cn(styles.textColor, styles.markdown)}>
              <ReactMarkdown>{description}</ReactMarkdown>
            </div>
          </>
        )}
      </Flex>
      {isLoading && (
        <Flex vertical gap={32} className={styles.skeleton}>
          {skeletonArray.map((_, index) => (
            <Flex key={index} align="space-between">
              <Flex flex={1} align="center" gap={16} key={index}>
                <Skeleton.Avatar active size="small" shape="square" />
                <Flex vertical gap={8} className={styles.skeletonWrapper}>
                  <Skeleton.Input active size="small" />
                  <Skeleton.Input size="small" />
                </Flex>
              </Flex>
              <Flex gap={12} align="center" className={styles.aside}>
                <Skeleton.Input active size="small" />
                <Skeleton.Avatar active size="small" shape="square" />
              </Flex>
            </Flex>
          ))}
        </Flex>
      )}
    </Flex>
  )
}
